import React from 'react';
import { resolveTheme, panelStyle, RAMPS } from '../themes';
import type { Theme } from '../themes';

interface ColorRampLegendProps {
  theme?: string | Theme;
  ramp?: string;
  min: string;
  max: string;
  label?: string;
  width?: number;
}

export function ColorRampLegend({ theme, ramp = 'inferno', min, max, label = 'Height (Z)', width = 160 }: ColorRampLegendProps) {
  const T = resolveTheme(theme);
  return (
    <div style={panelStyle(T, { padding: '10px 12px', width, font: `11px ${T.font}` })}>
      <div style={{
        fontSize: 10, color: T.textDim, textTransform: 'uppercase', letterSpacing: '0.08em',
        marginBottom: 6, fontWeight: T.headerWeight,
      }}>{label}</div>
      <div style={{
        height: 8, borderRadius: 1, background: RAMPS[ramp] ?? RAMPS.inferno, marginBottom: 4,
      }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', color: T.textDim, fontSize: 10, fontVariantNumeric: 'tabular-nums' }}>
        <span>{min}</span>
        <span>{ramp}</span>
        <span>{max}</span>
      </div>
    </div>
  );
}
